module.exports = "<div class=\"spinner\">\n  <div>\n    <ion-spinner name=\"crescent\"></ion-spinner>\n    <span> 数据加载中，请稍后... </span>\n  </div>\n</div>"